
/*
  UXS — INCOMING TRANSITION FINAL V13
  DAY2K / UNIDOS X EL SONIDO

  Usa el MP3 aprobado VOICE001 V13
  con la voz y el riser Gmaj9 juntos.

  Conserva:
  - Alienígena V4.2
  - Implosión orgánica
  - Reactividad al audio
  - Compartir / No compartir
  - Pantalla de señal entrante
*/

(function () {
  'use strict';

  function init() {
    const root = document.getElementById('uxs-experience');
    const canvas = document.getElementById('uxs-visualizer');
    const recording = document.getElementById('uxs-recording');

    if (
      !root ||
      !canvas ||
      !recording ||
      root.dataset.uxsIncomingV13
    ) return;

    root.dataset.uxsIncomingV13 = 'true';

    const AUDIO_URL = String(
      window.UXSIncomingVoiceURL || ''
    ).trim();

    const CUES = [
      { at: 0, text: 'ESPERA...' },
      { at: 2.368, text: 'CREO QUE... SIENTO ALGO.' },
      { at: 6.787, text: 'HAY ALGUIEN MÁS.' }
    ];

    const LENGTH = 9.648;

    let active = false;
    let raf = 0;
    let started = false;

    // ========================================
    // REPRODUCTOR VOICE001
    // ========================================

    const voice = document.createElement('audio');

    voice.id = 'uxs-incoming-voice001-player';
    voice.preload = 'auto';
    voice.hidden = true;

    if (AUDIO_URL) {
      voice.src = AUDIO_URL;
    }

    recording.appendChild(voice);

    // ========================================
    // SUBTÍTULOS
    // ========================================

    const subtitle = document.createElement('p');

    subtitle.id = 'uxs-incoming-narration';
    subtitle.setAttribute('aria-live', 'polite');

    recording.insertBefore(
      subtitle,
      recording.firstChild
    );

    // ========================================
    // BOTÓN PARA DESBLOQUEAR AUDIO
    // ========================================

    const unlock = document.createElement('button');

    unlock.id = 'uxs-incoming-unlock';
    unlock.type = 'button';
    unlock.textContent = 'CONTINUAR';
    unlock.hidden = true;

    recording.appendChild(unlock);

    // ========================================
    // ESTILOS
    // ========================================

    const style = document.createElement('style');

    style.id = 'uxs-incoming-v13-styles';

    style.textContent = `
      #uxs-incoming-narration {
        display: none;
        color: #fff;
        text-align: center;
        width: min(90vw, 440px);
        min-height: 40px;
        margin: 12px auto;
        font: 13px/1.9 monospace;
        letter-spacing: 1.4px;
      }

      #uxs-incoming-unlock {
        display: none;
        color: #fff;
        background: transparent;
        border: 1px solid #777;
        border-radius: 999px;
        padding: 14px 29px;
        font: 12px monospace;
        letter-spacing: 2px;
        cursor: pointer;
        margin: 10px auto;
      }

      #uxs-experience.uxs-incoming-transitioning
      #uxs-incoming-narration {
        display: block;
      }

      #uxs-experience.uxs-incoming-transitioning
      #uxs-incoming-unlock:not([hidden]) {
        display: block;
      }

      #uxs-experience.uxs-incoming-transitioning
      #uxs-incoming-panel {
        display: none !important;
      }

      #uxs-visualizer {
        transform-origin: center center;
      }
    `;

    document.head.appendChild(style);

    // ========================================
    // MATEMÁTICAS DE ANIMACIÓN
    // ========================================

    const clamp = (x, a, b) =>
      Math.max(a, Math.min(b, x));

    const smooth = t => {
      t = clamp(t, 0, 1);
      return t * t * (3 - 2 * t);
    };

    const lerp = (a, b, t) =>
      a + (b - a) * smooth(t);

    const inRange = (t, a, b) =>
      clamp((t - a) / (b - a), 0, 1);

    // ========================================
    // SINCRONIZACIÓN CON VOICE001 V13
    // ========================================

    function displayAt(t) {
      let cue = CUES[0];

      for (const c of CUES) {
        if (t >= c.at) {
          cue = c;
        }
      }

      subtitle.textContent = cue.text;

      // Conservamos el canvas original.
      // V4.2 lee esta escala para deformarse.

      let s;

      if (t < 2.368) {

        // ESPERA:
        // Inestabilidad inicial.
        s = lerp(
          1,
          0.73,
          inRange(t, 0, 2.368)
        );

      } else if (t < 5.85) {

        // CREO QUE... SIENTO ALGO:
        // Implosión profunda.
        s = lerp(
          0.73,
          0.13,
          inRange(t, 2.368, 5.85)
        );

      } else if (t < 6.787) {

        // Núcleo tembloroso.
        s = 0.13 + Math.sin(t * 19) * 0.014;

      } else if (t < 8.52) {

        // HAY ALGUIEN MÁS:
        // Liberación del organismo.
        s = lerp(
          0.13,
          1.035,
          inRange(t, 6.787, 8.52)
        );

      } else {

        // Recuperación suave.
        s = lerp(
          1.035,
          1,
          inRange(t, 8.52, LENGTH)
        );

      }

      canvas.style.transform = `scale(${s})`;
    }

    // ========================================
    // TERMINAR TRANSICIÓN
    // ========================================

    function cleanup() {
      cancelAnimationFrame(raf);
      raf = 0;

      voice.pause();

      subtitle.textContent = '';

      canvas.style.transform = 'scale(1)';

      unlock.hidden = true;

      root.classList.remove(
        'uxs-incoming-transitioning'
      );

      document.getElementById(
        'uxs-incoming-panel'
      )?.removeAttribute('aria-hidden');

      active = false;
      started = false;

      root.dispatchEvent(
        new CustomEvent(
          'uxs:incoming-transition-ended',
          { bubbles: true }
        )
      );
    }

    // ========================================
    // ACTUALIZAR CADA FRAME
    // ========================================

    function tick() {
      if (!active || !started) return;

      const t = voice.currentTime;

      displayAt(t);

      if (
        voice.ended ||
        t >= LENGTH - 0.07
      ) {
        cleanup();
        return;
      }

      raf = requestAnimationFrame(tick);
    }

    // ========================================
    // REPRODUCCIÓN
    // ========================================

    async function tryPlay() {
      if (!active || started) return;

      try {
        await voice.play();

        if (!active) return;

        started = true;
        unlock.hidden = true;

        tick();

      } catch (err) {

        console.warn(
          'UXS VOICE001 playback needs a user gesture:',
          err
        );

        subtitle.textContent = AUDIO_URL
          ? 'HAY UNA SEÑAL ESPERANDO.'
          : 'NO SE ENCONTRÓ EL AUDIO VOICE001.';

        unlock.hidden = !AUDIO_URL;
      }
    }

    // ========================================
    // INICIAR ESCENA
    // ========================================

    function start() {
      if (active) return;

      active = true;
      started = false;

      root.classList.add(
        'uxs-incoming-transitioning'
      );

      document.getElementById(
        'uxs-incoming-panel'
      )?.setAttribute(
        'aria-hidden',
        'true'
      );

      subtitle.textContent = '';

      canvas.style.transform = 'scale(1)';

      if (!AUDIO_URL) {
        console.error(
          'UXS: Missing window.UXSIncomingVoiceURL.'
        );

        subtitle.textContent =
          'NO SE ENCONTRÓ EL AUDIO VOICE001.';

        return;
      }

      voice.pause();
      voice.currentTime = 0;

      tryPlay();
    }

    // ========================================
    // EVENTOS
    // ========================================

    unlock.addEventListener(
      'click',
      tryPlay
    );

    voice.addEventListener(
      'ended',
      () => {
        if (active) cleanup();
      }
    );

    voice.addEventListener(
      'error',
      () => {
        if (!active) return;

        subtitle.textContent =
          'NO SE PUDO CARGAR VOICE001.';

        unlock.hidden = true;

        console.error(
          'UXS audio error: verify the Shopify file URL.'
        );
      }
    );

    root.addEventListener(
      'uxs:incoming-started',
      start
    );

    console.log(
      'UXS Incoming Transition V13 ready'
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();
